<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted () {
      // 软键盘收起的事件处理
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('iphone') > 0 || ua.indexOf('ipad') > 0) {
        // 这里监听键盘收起，然后滚动顶部
        document.body.addEventListener('focusout', () => {
          // 键盘收起，元素错位
          document.body.scrollTop = document.body.scrollHeight
        })
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue